export default __webpack_public_path__ + "static/media/lock-large.b939ae28.svg";